import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import SuccessPage from "./pages/SuccessPage";
import "./App.css";
import {CONST_CONF,CONST_LABELS,CONST_LABELS_LNG} from "../app/pages/Commons";
const App: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter >
        <Routes>
          <Route path="/mkt/:country/:operator/:merchant/:affiliate/:lp" element={<HomePage />} />
          {/*<Route path="/mkt/:cp/:country/:lp/" element={<HomePage />} />*/}
          {/* old */}
          {/* <Route path="/outlet/:outletName" element={<OrderPage />} /> */}
          <Route path="/mkt/:country/:operator/:merchant/:affiliate/:lp/success" element={<SuccessPage />} />

          {/* <Route path="/:outletName/item/:ID" element={<ProductDetailPage />} /> */}
        </Routes>
      </BrowserRouter>
      {/* <HomePage /> */}
    </div>
  );
};

export default App;
